import { MetaData, ServicesPage } from '@/components'
import calcCurrentDirection from '@/lib/calcCurrentDirection'

export default function NextServicesPage(props) {
  const { meta } = props;
  const title = meta?.title || "ELEMENTAL Day Surgical Center Services";
  const description = meta?.description || "ELEMENTAL Day Surgical Center"

  return (
    <>
      <MetaData title={title} description={description} />
      <ServicesPage {...props} />
    </>
  )
}

NextServicesPage.getInitialProps = async ({ query, res, api }) => {
  if (query.direction) {
    
    const specialRedirects = {
      'hirurgiya': '/general-surgery',
      'endoscopy': '/endoscopy-diagnostics', 
      'a': '/services'  
    };
    
    if (specialRedirects[query.direction]) {
      const redirectPath = specialRedirects[query.direction];
      
      if (res) {
        res.writeHead(301, { Location: redirectPath });
        res.end();
        return {};
      }

      if (typeof window !== 'undefined') {
        window.location.replace(redirectPath);
        return {};
      }
    } else {
      try {
        await api.directions({ direction: query.direction });
      
        const redirectPath = `/${query.direction}`;
        
        if (res) {
          res.writeHead(301, { Location: redirectPath });
          res.end();
          return {};
        }

        if (typeof window !== 'undefined') {
          window.location.replace(redirectPath);
          return {};
        }
      } catch (error) {
        const redirectPath = '/services';
        
        if (res) {
          res.writeHead(301, { Location: redirectPath });
          res.end();
          return {};
        }

        if (typeof window !== 'undefined') {
          window.location.replace(redirectPath);
          return {};
        }
      }
    }
  }

  const response = await api.directions({ ...query });
  const directions = response.directions || []
  const cur = calcCurrentDirection(null, directions, directions[0])
  const requestSlug = cur?.children?.[0]?.slug || cur?.slug

  let services = response.services || []
  let current_direction = response.current_direction

  if (requestSlug) {
    const servicesData = await api.directions({ direction: requestSlug })
    services = servicesData.services || []
    current_direction = servicesData.current_direction || current_direction
  }

  return {
    meta: response.meta,
    banners: response.banners,
    directions,
    short_content: response.short_content,
    services,
    current_direction,
    all_services: response.all_services
  }
}
